var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStars = function SvgStars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 131,
    height: 25,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#stars_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00B67A",
    d: "M24.563 0H0v25h24.563V0ZM51.172 0H26.609v25h24.563V0ZM77.781 0H53.22v25H77.78V0ZM104.391 0H79.828v25h24.563V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCDCE6",
    d: "M131 0h-12.281v25H131V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B67A",
    d: "M118.719 0h-12.281v25h12.281V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m12.281 16.849 3.736-.964 1.56 4.896-5.296-3.932Zm8.597-6.328h-6.575L12.28 4.219l-2.02 6.302H3.684l5.321 3.906-2.02 6.302 5.321-3.906 3.275-2.396 5.296-3.906ZM38.89 16.849l3.736-.964 1.561 4.896-5.296-3.932Zm8.598-6.328h-6.576l-2.021-6.302-2.021 6.302h-6.576l5.322 3.906-2.022 6.302 5.322-3.906 3.275-2.396 5.297-3.906ZM65.5 16.849l3.736-.964 1.56 4.896L65.5 16.85Zm8.597-6.328h-6.575L65.5 4.219 63.48 10.52h-6.576l5.322 3.906-2.021 6.302 5.322-3.906 3.275-2.396 5.296-3.906ZM92.11 16.849l3.735-.964 1.56 4.896-5.295-3.932Zm8.596-6.328h-6.575L92.11 4.219l-2.022 6.302h-6.575l5.322 3.906-2.022 6.302 5.322-3.906 3.275-2.396 5.296-3.906ZM118.719 16.849l3.735-.964 1.561 4.896-5.296-3.932Zm8.597-6.328h-6.576l-2.021-6.302-2.021 6.302h-6.576l5.322 3.906-2.021 6.302 5.322-3.906 3.275-2.396 5.296-3.906Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "stars_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h131v25H0z"
  })))));
};
export default SvgStars;